module.exports = __webpack_public_path__ + "img/setup-koenen-min.f07ba63c.jpg";